import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import type { ArticleGroup } from '../types'
import ArticleAccordionRow from './ArticleAccordionRow'

interface ArticleAccordionProps {
  articleGroups: ArticleGroup[]
}

const ArticleAccordion = ({ articleGroups }: ArticleAccordionProps) => {
  const nonEmptyGroups = articleGroups.filter((group) => group.articles.length > 0)

  return (
    <Accordion type="multiple" defaultValue={[`group-0`]} className="w-full">
      {nonEmptyGroups.map((group, i) => (
        <AccordionItem
          key={i}
          value={`group-${i}`}
          className={`${i !== nonEmptyGroups.length - 1 ? '' : '!border-none'}`}
        >
          <AccordionTrigger
            className={`text-sm font-medium text-foreground bg-neutral-100 px-2 ${i === 0 ? 'rounded-t-lg' : ''} ${i === nonEmptyGroups.length - 1 ? 'rounded-b-lg' : ''} hover:no-underline`}
          >
            {group.title}
          </AccordionTrigger>
          <AccordionContent>
            <div className="flex flex-col divide-y divide-border">
              {group.articles.map((article, j) => (
                <ArticleAccordionRow key={j} article={article} />
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}

export default ArticleAccordion
